import script from "./PlaMpEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaMpEditPage.vue?vue&type=script&setup=true&lang=js"

import "./PlaMpEditPage.vue?vue&type=style&index=0&id=596fdf29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596fdf29"]])

export default __exports__